import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

import { SupplierAutocompleteHit } from '../SupplierAutocomplete.types';
import { Address } from '~/components/Address/Address';
import { ReferenceTag } from '~/components/ReferenceTag/ReferenceTag';

import { Root, Actions, supplierOptionClasses as classes } from './SupplierOption.styled';

export interface SupplierOptionProps {
  data: SupplierAutocompleteHit;
  renderActions?: (item: SupplierAutocompleteHit) => ReactNode;
}

export const SupplierOption = ({ data, renderActions, ...props }: SupplierOptionProps) => {
  return (
    <Root {...props}>
      <Box
        sx={{
          flex: 1,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: 'text.primary',
          }}
        >
          {data.value}
          <ReferenceTag variant="caption" color="text.secondary">
            {data.entity.sourceReference}
          </ReferenceTag>
        </Typography>
        {data.entity.locations.map((location) => (
          <Typography
            component="div"
            key={location.id}
            variant="caption"
            sx={{
              color: 'text.secondary',
              display: 'block',
            }}
          >
            <Address
              street={location.address}
              city={location.city}
              postalCode={location.postalCode}
              countryCode={location.countryCode}
            />
          </Typography>
        ))}
      </Box>
      {renderActions ? <Actions className={classes.actions}>{renderActions(data)}</Actions> : null}
    </Root>
  );
};
